/* ==========================================================================
   PDP enhancements - loaded on product pages only, from the end of <body>.

   Deliberately additive: everything here attaches to markup that
   sections/ipl-product-page.liquid already renders, so that 38KB section does
   not have to be rewritten to gain these three features.
   ========================================================================== */

(function () {
  var root = document.getElementById('iplp');
  if (!root) return;

  /* ------------------------------------------------------------------------
     1. Prices on the option axes that actually vary
     ------------------------------------------------------------------------
     The section's own pill-pricing runs only when a product has exactly one
     option, or when a long option list is rendered as a <select> and converted
     to dimension axes. A two-option product whose sizes render as plain pills
     (0.6m wide at 450 vs 0.91m wide at 650) falls through both paths and shows
     no price at all - the buyer has to click each option to find out what it
     costs.

     Price is added per AXIS, not per pill. If every value on an axis carries
     the same set of prices, that axis does not drive price, and stamping the
     same number on all six colour pills is noise rather than information.
     ------------------------------------------------------------------------ */
  (function () {
    var node = document.getElementById('iplp-variant-prices');
    if (!node) return;

    var data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }
    if (!data || !data.length) return;

    var fmt = (window.theme && window.theme.moneyFormat) || '{' + '{amount}' + '}';
    var OPEN = '{' + '{', CLOSE = '}' + '}';

    function amount(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      var ip = parts[0], grouped = '';
      while (ip.length > 3) { grouped = ',' + ip.slice(-3) + grouped; ip = ip.slice(0, -3); }
      return ip + grouped + '.' + parts[1];
    }

    /* Full store format, e.g. "450.00" -> "GBP450.00 inc VAT". */
    function money(cents) {
      var o = fmt.indexOf(OPEN), c = fmt.indexOf(CLOSE);
      var out = (o >= 0 && c > o) ? fmt.slice(0, o) + amount(cents) + fmt.slice(c + 2) : amount(cents);
      return out.replace(/<[^>]+>/g, '').trim();
    }

    /* Currency symbol only, no trailing suffix. The store's money format ends
       in " inc VAT", and appending a unit to that produces the nonsense
       "450.00 inc VAT/m2". The headline figure beside it already carries the
       tax wording, so the unit price does not need to repeat it. */
    function moneyBare(cents) {
      var o = fmt.indexOf(OPEN);
      var prefix = o >= 0 ? fmt.slice(0, o) : '';
      return (prefix + amount(cents)).replace(/<[^>]+>/g, '').trim();
    }

    /* "10m Length x 0.6m Wide x 6mm Thickness" -> 6 m2. Trade buyers compare
       rolls on price per square metre, not on the price of a roll - and here
       it surfaces that the wider roll is the better value. */
    function areaOf(value) {
      var L = /([\d.]+)\s*m\s*Length/i.exec(value);
      var W = /([\d.]+)\s*m\s*Wide/i.exec(value);
      if (L && W) {
        var a = parseFloat(L[1]) * parseFloat(W[1]);
        return a > 0 ? a : 0;
      }
      var cov = /covers\s*([\d.]+)\s*m/i.exec(value);
      return cov ? parseFloat(cov[1]) : 0;
    }

    var axes = root.querySelectorAll('.iplp__opt');

    Array.prototype.forEach.call(axes, function (axis, i) {
      var pills = axis.querySelectorAll('[data-optpill]');
      if (!pills.length) return;

      /* every distinct price reachable for each value of this axis */
      var sets = {};
      data.forEach(function (v) {
        var val = v.o && v.o[i];
        if (val == null) return;
        if (!sets[val]) sets[val] = {};
        sets[val][v.p] = 1;
      });

      var keys = Object.keys(sets);
      if (!keys.length) return;

      var sigs = keys.map(function (k) {
        return Object.keys(sets[k]).map(Number).sort(function (a, b) { return a - b; }).join(',');
      });
      var varies = sigs.some(function (s) { return s !== sigs[0]; });
      if (!varies) return;

      Array.prototype.forEach.call(pills, function (pill) {
        if (pill.querySelector('.iplp__pill-price')) return;   /* section already priced it */

        var val = pill.getAttribute('data-value');
        var priceSet = sets[val];
        if (!priceSet) return;

        var nums = Object.keys(priceSet).map(Number).sort(function (a, b) { return a - b; });
        var label = nums.length > 1 ? 'from ' + money(nums[0]) : money(nums[0]);

        var area = areaOf(val);
        if (area) label += ' · ' + moneyBare(nums[0] / area) + '/m²';

        var span = document.createElement('span');
        span.className = 'iplp__pill-price';
        span.textContent = label;
        pill.appendChild(span);
      });
    });
  })();

  /* ------------------------------------------------------------------------
     2. Gallery lightbox
     ------------------------------------------------------------------------
     The stage image is served far smaller than its source (1400px source in a
     632px slot - 2.2x of detail sitting unused), and the section's gallery only
     swaps src on thumbnail click. For a product sold on surface texture, being
     unable to look closely is the biggest single gap against a marketplace
     listing. Asks the Shopify CDN for width=2048 so the lightbox shows real
     detail rather than an upscale of the stage image.
     ------------------------------------------------------------------------ */
  (function () {
    var stage = document.getElementById('iplpMain');
    if (!stage) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.iplp__thumb'));

    /* Read at open time rather than once at load: the colour filter in 3 below
       hides the thumbnails belonging to the other colours, and a viewer still
       paging through all fourteen images would undo that one arrow press at a
       time. */
    function currentSrcs() {
      var shown = thumbs.filter(function (t) { return !t.hidden; });
      if (!shown.length) shown = thumbs;
      var list = shown.map(function (t) { return t.getAttribute('data-full'); }).filter(Boolean);
      return list.length ? list : [stage.getAttribute('src')];
    }

    var srcs = currentSrcs();
    if (!srcs.length) return;

    var box, img, count, lastFocus, idx = 0;

    stage.setAttribute('role', 'button');
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('aria-label', 'Open full-size image');

    function hiRes(u) { return u ? u.split('?')[0] + '?width=2048' : u; }

    function build() {
      box = document.createElement('div');
      box.className = 'iplp-lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product image viewer');
      box.innerHTML =
        '<button type="button" class="iplp-lb__close" aria-label="Close image viewer">×</button>' +
        '<button type="button" class="iplp-lb__nav iplp-lb__prev" aria-label="Previous image">‹</button>' +
        '<img class="iplp-lb__img" alt="">' +
        '<button type="button" class="iplp-lb__nav iplp-lb__next" aria-label="Next image">›</button>' +
        '<div class="iplp-lb__count" aria-live="polite"></div>';
      document.body.appendChild(box);

      img = box.querySelector('.iplp-lb__img');
      count = box.querySelector('.iplp-lb__count');

      box.querySelector('.iplp-lb__close').addEventListener('click', close);
      box.querySelector('.iplp-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      box.querySelector('.iplp-lb__next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
    }

    function show() {
      img.src = hiRes(srcs[idx]);
      img.alt = stage.getAttribute('alt') || '';
      count.textContent = (idx + 1) + ' / ' + srcs.length;
      var multi = srcs.length > 1;
      box.querySelector('.iplp-lb__prev').hidden = !multi;
      box.querySelector('.iplp-lb__next').hidden = !multi;
      count.hidden = !multi;
    }

    function go(d) { idx = (idx + d + srcs.length) % srcs.length; show(); }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    }

    function open() {
      if (!box) build();
      srcs = currentSrcs();
      /* open on whatever the stage is currently showing */
      var cur = (stage.getAttribute('src') || '').split('?')[0];
      var found = srcs.map(function (s) { return (s || '').split('?')[0]; }).indexOf(cur);
      idx = found > -1 ? found : 0;

      lastFocus = document.activeElement;
      show();
      box.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      box.querySelector('.iplp-lb__close').focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    stage.addEventListener('click', open);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  })();

  /* ------------------------------------------------------------------------
     3. The gallery follows the colour choice
     ------------------------------------------------------------------------
     The section renders every image of the product in one strip and only ever
     swaps the stage image on a thumbnail click. Its one attempt to follow the
     variant - jump to v.featured_image - cannot fire on this store, because no
     variant has an image assigned in the admin. So picking White left a black
     mat on screen, and ?variant= links arrived showing the wrong colour before
     anything had been clicked at all. On a product sold in six colours that is
     the most misleading thing the page can do.

     Which image shows which colour is read from the alt text, because that is
     where this store already records it ("Green open-grid matting laid as a
     barefoot walkway..."). An image whose alt names no colour - a context shot
     of the product in use - belongs to every colour and stays in the strip for
     all of them; an image naming two is treated the same way rather than
     guessed at.

     The feature switches itself off unless every colour ends up with at least
     one image of its own. A product with thin or inaccurate alt text then
     keeps the full gallery, which is merely unhelpful, rather than a filtered
     one, which would be wrong.
     ------------------------------------------------------------------------ */
  (function () {
    var stage = document.getElementById('iplpMain');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.iplp__thumb'));
    if (!stage || thumbs.length < 2) return;

    function altOf(t) {
      var im = t.querySelector('img');
      return ((im && im.getAttribute('alt')) || '');
    }

    /* the section swaps the stage src on a thumbnail click but leaves the alt
       text of the previous image behind, so the description and the picture
       disagree until the next variant change */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { stage.setAttribute('alt', altOf(t)); });
    });

    /* the label reads "Color <span>White</span>", so the option name is the
       text outside the span - taking all of it would read the current value
       as part of the name */
    function optionName(o) {
      var lab = o.querySelector('.iplp__opt-label');
      if (!lab) return '';
      var name = '';
      Array.prototype.forEach.call(lab.childNodes, function (n) {
        if (n.nodeType === 3) name += n.textContent;
      });
      return name.replace(/\s+/g, ' ').trim();
    }

    var block = null;
    Array.prototype.forEach.call(root.querySelectorAll('.iplp__opt'), function (o) {
      if (block) return;
      if (!/colou?r|shade|finish/i.test(optionName(o))) return;
      if (o.querySelectorAll('[data-optpill]').length > 1) block = o;
    });
    if (!block) return;

    var values = Array.prototype.map.call(
      block.querySelectorAll('[data-optpill]'),
      function (p) { return p.getAttribute('data-value'); }
    ).filter(Boolean);
    if (values.length < 2) return;

    /* whole-word match, so "Red" is not found inside "covered" or "required" */
    var tests = values.map(function (v) {
      var word = String(v).toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return { value: v, re: new RegExp('(^|[^a-z])' + word + '([^a-z]|$)') };
    });

    var owner = thumbs.map(function (t) {
      var alt = altOf(t).toLowerCase(), hit = null;
      tests.forEach(function (c) {
        if (!c.re.test(alt)) return;
        hit = hit === null ? c.value : false;   /* names two colours: decide nothing */
      });
      return hit || null;
    });

    var groups = {}, confident = true;
    values.forEach(function (v) {
      var key = String(v).toLowerCase();
      var own = 0;
      /* filtered in document order, so the strip keeps the merchant's ordering */
      groups[key] = thumbs.filter(function (t, i) {
        if (!owner[i]) return true;                     /* no colour named: shown for all */
        if (String(owner[i]).toLowerCase() !== key) return false;
        own++;
        return true;
      });
      if (!own) confident = false;
    });
    if (!confident) return;

    function activate(t) {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      stage.setAttribute('src', t.getAttribute('data-full'));
      stage.setAttribute('alt', altOf(t));
    }

    var lastKey = null;

    function apply() {
      var pill = block.querySelector('[data-optpill].active');
      if (!pill) return;
      var key = String(pill.getAttribute('data-value') || '').toLowerCase();
      var list = groups[key];
      if (!list || !list.length) return;

      thumbs.forEach(function (t) {
        var on = list.indexOf(t) > -1;
        t.hidden = !on;
        /* .iplp__thumb carries display:block, which beats the user-agent
           [hidden] rule, so the attribute on its own hides nothing */
        t.style.display = on ? '' : 'none';
      });

      /* a new colour always opens on a photo of that colour; within one colour
         the buyer keeps the shot they clicked through to while changing size */
      var active = root.querySelector('.iplp__thumb.active');
      if (key !== lastKey || !active || list.indexOf(active) < 0) activate(list[0]);
      lastKey = key;
    }

    apply();

    /* the section owns the pills and fires no event of its own, so the active
       class moving is the signal - the same one ipl-pdp-a11y.js reads. The
       thumbnails sit outside this block, so activate() cannot retrigger it.
       setTimeout rather than requestAnimationFrame: rAF does not run while the
       tab is in the background, and a latch waiting on one would stay shut for
       the rest of the session. */
    var queued = null;
    new MutationObserver(function () {
      if (queued) return;
      queued = setTimeout(function () { queued = null; apply(); }, 0);
    }).observe(block, { attributes: true, subtree: true, attributeFilter: ['class'] });
  })();
})();